// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__34Wfy","title":"Images90_title__3B5eJ","images":"Images90_images__3vPS1"};